import { createGlobalStyle } from 'styled-components';
import customClasses from './customClasses';
import customProperties from './customProperties';
import fonts from './fonts';
import reset from './reset';

export const GlobalStyle = createGlobalStyle`
  ${reset}
  ${customProperties}
  ${customClasses}
  ${fonts}
`;

export default GlobalStyle;
